import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import './StudentProfileEvent.css';
import SurveyStep from './SurveyStep';
import AnalysisStep from './AnalysisStep';
import ResultStep from './ResultStep';
import { NamedGrayIcon } from '../../../components/icons/GrayIconBox';

const StudentProfileEvent = () => {
  const [currentStep, setCurrentStep] = useState('landing'); // landing, survey, analysis, result
  const [surveyData, setSurveyData] = useState({});
  const [analysisResult, setAnalysisResult] = useState(null);

  const handleStartSurvey = () => {
    setCurrentStep('survey');
  };

  const handleSurveyComplete = (data) => {
    //console.log('🔍 설문 완료 데이터:', data);
    setSurveyData(data);
    setCurrentStep('analysis');
    
    // 실제 페르소나 분석 (mock 제거)
    setTimeout(() => {
      // ResultStep에서 determinePersonaFromSurvey 함수가 실행되도록 
      // persona를 null로 설정하여 실제 분석이 이루어지도록 함
      const analysisResult = {
        persona: null, // null로 설정하여 ResultStep에서 실제 분석하도록
        needsDetailGeneration: true // AI 생기부 생성이 필요함을 표시
      };
      
      setAnalysisResult(analysisResult);
      setCurrentStep('result');
    }, 3000);
  };

  const renderLandingPage = () => (
    <div className="student-profile-event-landing">
      <div className="student-profile-event-landing-container">
        <div className="student-profile-event-landing-header">
          <div className="student-profile-event-dolphin-character">
            <div className="student-profile-event-dolphin-icon">
              <NamedGrayIcon name="clipboard" boxSize={48} />
            </div>
          </div>
          <h1 className="student-profile-event-landing-title">
            나만의 <span className="student-profile-event-highlight">학생 생기부</span><br/>
            받아보기
          </h1>
          <p className="student-profile-event-landing-subtitle">
            평소 학교생활과 친구 관계를 기반으로<br/>
            <strong>개인화된 학생 생기부 문구</strong>를 <strong>왓퀴즈AI</strong>가 만들어 드려요.
          </p>
        </div>

        <div className="student-profile-event-landing-cta">
          <div className="student-profile-event-time-info">
            <span className="student-profile-event-time-badge">3분이면 완성</span>
          </div>
          <button 
            className="student-profile-event-start-button"
            onClick={handleStartSurvey}
          >
            <span className="student-profile-event-button-text">내 학생 유형 알아보기</span>
            <span className="student-profile-event-button-arrow">→</span>
          </button>
        </div>

        <div className="student-profile-event-landing-footer">
          <p className="student-profile-event-footer-text">
            <strong>왓퀴즈 특별 이벤트</strong> - 나는 어떤 학생일까?
          </p>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <Helmet>
        <title>학생 생기부 이벤트 | WhatQuiz</title>
        <meta name="description" content="나만의 학생 생기부를 AI가 분석해드립니다. 왓퀴즈 특별 이벤트!" />
      </Helmet>

      <div className="student-profile-event-main">
        {currentStep === 'landing' && renderLandingPage()}
        {currentStep === 'survey' && (
          <SurveyStep 
            onComplete={handleSurveyComplete}
            onBack={() => setCurrentStep('landing')}
          />
        )}
        {currentStep === 'analysis' && (
          <AnalysisStep />
        )}
        {currentStep === 'result' && (
          <ResultStep 
            result={analysisResult}
            surveyData={surveyData}
            onRestart={() => {
              setCurrentStep('landing');
              setSurveyData({});
              setAnalysisResult(null);
            }}
          />
        )}
      </div>
    </>
  );
};

export default StudentProfileEvent;